<template>
  <div>
    <el-upload
      v-loading="loading"
      :limit="1"
      :http-request="loadFile"
      :before-remove="beforeRemove"
      :on-exceed="handleExceed"
      :file-list="fileList"
      :accept="acceptedFile"
      action=""
    >
      <el-button class="upload-button">
        {{ $t('admin.uploadFileButton') }}
      </el-button>
      <div class="el-upload__tip">
        {{ $t('uploadMenu.uploadHint') }}
      </div>
    </el-upload>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import bulkOrdersParser from '@/utils/bulkOrdersParser';
//import moment from 'moment';

export default {
  name: 'OrdersUploader',
  props: {
    acceptedFile: {
      type: String,
      required: true,
    },
    officeId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      fileList: [],
      dataFromFile: {},
      loading: false,
    };
  },
  computed: {
    ...mapState('offices', { offices: (state) => state.offices }),
    ...mapState('diets', { diets: (state) => state.diets }),
    ...mapState('events', { mealEvents: (state) => state.mealEvents }),
    ...mapState('orders', {
      ordersUploadedCorrectly: (state) => state.bulkCreationOrdersCorrectly,
    }),
  },
  watch: {
    ordersUploadedCorrectly: 'handleUploadedCorrectlyChange',
  },
  methods: {
    handleExceed() {
      this.$message.warning(this.$t('admin.exceededFileLimitMessage'));
    },
    beforeRemove() {
      return this.$confirm(this.$t('admin.beforeRemoveFileMessage'));
    },
    async loadFile(fileData) {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        try {
          const fileContent = fileReader.result;
          this.dataFromFile = bulkOrdersParser(fileContent, this.officeId, this.mealEvents);

          this.loading = true;
          this.createBulkOrders(this.dataFromFile);
        } catch (errorFromMenuParser) {
          this.$message.error(this.$t(errorFromMenuParser.message));
          this.fileList = [];
        }
      };
      fileReader.readAsText(fileData.file);
    },

    handleUploadedCorrectlyChange() {
      if (this.ordersUploadedCorrectly === undefined) {
        // eslint-disable-next-line no-useless-return
        return;
      }
      if (this.ordersUploadedCorrectly) {
        this.loading = false;
        this.$message.success(this.$t('admin.menuParserMessages.successUpload'));
      } else {
        this.loading = false;
        this.$message.error(this.$t('admin.menuParserMessages.errorUpload'));
        this.fileList = [];
      }
    },
    ...mapActions('orders', {
      createBulkOrders: 'createBulkOrders',
    }),
  },
};
</script>
<style scoped lang="scss">
@import '../../scss/variables';
.el-message-box {
  height: 180px;
  &__message p {
    font-family: 'Avenir';
  }
}
.upload-button {
  width: 105px;
}
/deep/ .el-upload {
  &__tip {
    text-align: center;
    font-size: $label-description-text-size;
  }
}
/deep/ .el-upload-list {
  &--text {
    text-align: left;
  }
  /deep/ .el-icon-close-tip {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/orders/OrdersUploader.vue